var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`z-index: ${_vm.zIndex}`)},[_c('div',{staticClass:"w-full shadow-lg transform blur-dim",style:(_vm.inlineStyles)},[_c('img',{attrs:{"src":_vm.cardImage,"alt":_vm.card.label}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }